import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const Feedback00Table: GenericTableSchemaInterface = {
  id: "feedback-00",
  name: "Feedback 00",
  description: "This table contains data regarding feedback.",
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: "Operator Name",
      variable: VarKey.OrgName
    },
    c02: {
      name: "Facility ID",
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: "Experiment Type"
    },
    c04: {
      name: "Rating Value"
    },
    c05: {
      name: "Promoter Start"
    },
    c06: {
      name: "Passive Start"
    },
    c07: {
      name: "Detractor Start"
    },
    c08: {
      name: "Has Google Review URL"
    },
    c09: {
      name: "GR - Sure"
    },
    c10: {
      name: "GR - No thanks"
    },
    c11: {
      name: "Topic - Most Helpful"
    },
    c12: {
      name: "Topic - Least Helpful"
    },
    c13: {
      name: "Open Value"
    },
    c14: {
      name: "Sequence"
    }
  }
};
